// utils/workGroup.js
//
// Which team's work a ticket is -- the server's `work_group` from GET /tasks
// (backend services/ticketFlowService.js#workGroupSql), derived from the
// ticket FLOW, never from the creator's role alone:
//   IT Support complaint                      -> TECHNICIAN  (whoever raised it)
//   Developer Own Ticket / DEVELOPMENT, BUG,
//     TESTING, DEPLOYMENT                     -> DEVELOPER
//   Data Analyst Own Ticket                   -> DATA_ANALYST
//   any other type                            -> the current owner's role, else none
// The same group decides which role is offered as the ticket's assignee.

export const WORK_GROUP = {
  TECHNICIAN: "TECHNICIAN",
  DEVELOPER: "DEVELOPER",
  DATA_ANALYST: "DATA_ANALYST",
};

// [tab key, label, work group | null for "All"]
export const WORK_GROUP_TABS = [
  ["all", "All", null],
  ["developer", "Developer", WORK_GROUP.DEVELOPER],
  ["data-analyst", "Data Analyst", WORK_GROUP.DATA_ANALYST],
  ["technician", "Technician / IT Support", WORK_GROUP.TECHNICIAN],
];

// Role (as used by assignee filtering) for each group.
export const GROUP_ROLE = {
  [WORK_GROUP.TECHNICIAN]: "technician",
  [WORK_GROUP.DEVELOPER]: "developer",
  [WORK_GROUP.DATA_ANALYST]: "data analyst",
};

export const GROUP_ASSIGN_NOUN = {
  [WORK_GROUP.TECHNICIAN]: "Technician",
  [WORK_GROUP.DEVELOPER]: "Developer",
  [WORK_GROUP.DATA_ANALYST]: "Data Analyst",
};

const DEVELOPER_TASK_TYPES = ["DEVELOPMENT", "BUG", "TESTING", "DEPLOYMENT"];
const text = (v) => (v === null || v === undefined ? "" : String(v)).trim();
const roleKey = (r) => text(r).toLowerCase().replace(/[^a-z]+/g, "-");
const ROLE_TO_GROUP = {
  developer: WORK_GROUP.DEVELOPER,
  "data-analyst": WORK_GROUP.DATA_ANALYST,
  technician: WORK_GROUP.TECHNICIAN,
};

/** The ticket's work group: the server's work_group, else the same rule from its flow. */
export function workGroupOf(task) {
  if (!task) return null;
  const server = text(task.work_group).toUpperCase();
  if (server) return WORK_GROUP[server] || null;
  const flow = text(task.ticket_flow).toUpperCase();
  if (flow === "IT_SUPPORT_COMPLAINT") return WORK_GROUP.TECHNICIAN;
  if (flow === "OWN_TICKET") return ROLE_TO_GROUP[roleKey(task.created_by_role)] || null;
  const code = (flow || text(task.task_type_code)).toUpperCase();
  if (!code || code === "IT_SUPPORT") return WORK_GROUP.TECHNICIAN;
  if (DEVELOPER_TASK_TYPES.includes(code)) return WORK_GROUP.DEVELOPER;
  return ROLE_TO_GROUP[roleKey(task.assigned_to_role)] || null;
}

export const filterByWorkGroup = (rows, tabKey) => {
  const tab = WORK_GROUP_TABS.find(([key]) => key === tabKey);
  if (!tab || !tab[2]) return rows;
  return rows.filter((t) => workGroupOf(t) === tab[2]);
};
